export enum ENVIRONMENTS {
  PRODUCTION = 'production',
  STAGING = 'staging',
  DEMO = 'demo',
  DEVELOPMENT = 'development',
  LOCAL = 'local',
  ESSENSYS = 'essensys',
  TEST = 'test',
}

export const DEV_ENV = [
  ENVIRONMENTS.DEVELOPMENT,
  ENVIRONMENTS.LOCAL,
  ENVIRONMENTS.TEST,
];

export const DEFAULT_WHITELABEL = 'lane';

export const ANONYMOUS_ID = '00000000-55d5-ef82-6de8-e0531944e434';

export const RELATED_SPACES_CONCURRENCY_LIMIT = 5;

const EARTH_EQUATOR_LENGTH = 40075; // Length of the equator in km
export const LONGEST_DISTANCE_ON_EARTH = EARTH_EQUATOR_LENGTH / 2;

export const DEFAULT_NOREPLY_EMAIL = 'no-reply@activate.vts.com';
// used for sending emails from Activate to Axiis
export const NOREPLY_EMAIL = 'info@mybtenantapp.com';

export const EARLIEST_DATE = new Date(1);
export const LATEST_DATE = new Date(6307200000000);

export const ALLOWED_CHARACTERS_PATTERN = /^(?!\s*$)[-'' a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF\u0100-\u017F\u0180-\u024F\u1E00-\u1EFF\u3040-\u309F\u30A0-\u30FF\u4e00-\u9fff\u0E00-\u0E7F]+$/u;
